// extracted by mini-css-extract-plugin
export default {"container":"styles__container___reuMX","label":"styles__label___td9yG"};